import React from "react";
import { useTranslation } from "react-i18next";
import useLangNavigate from "../../hooks/useLangNavigate";
import { usePageMeta } from "../../hooks/useMeta";
import { LandingHeader, LandingFooter } from "../../components/landing";
import AudienceCard from "../../components/landing/AudienceCard";

// Import images for audience cards
import restoImg from "../../assets/img/landing/resto.webp";
import customerImg from "../../assets/img/landing/customer.webp";
import companyImg from "../../assets/img/landing/company.webp";

function LandingEntry() {
  const { t } = useTranslation();
  const navigate = useLangNavigate();

  const audiences = [
    {
      variant: "restaurant",
      title: t("landing.entry.audiences.restaurant.title"),
      benefits: [
        t("landing.entry.audiences.restaurant.benefit1"),
        t("landing.entry.audiences.restaurant.benefit2"),
        t("landing.entry.audiences.restaurant.benefit3"),
      ],
      cta: t("landing.entry.audiences.restaurant.cta"),
      image: restoImg,
      path: "restaurants",
    },
    {
      variant: "consumer",
      title: t("landing.entry.audiences.consumer.title"),
      benefits: [
        t("landing.entry.audiences.consumer.benefit1"),
        t("landing.entry.audiences.consumer.benefit2"),
        t("landing.entry.audiences.consumer.benefit3"),
      ],
      cta: t("landing.entry.audiences.consumer.cta"),
      image: customerImg,
      path: "consumers",
    },
    {
      variant: "company",
      title: t("landing.entry.audiences.company.title"),
      benefits: [
        t("landing.entry.audiences.company.benefit1"),
        t("landing.entry.audiences.company.benefit2"),
        t("landing.entry.audiences.company.benefit3"),
      ],
      cta: t("landing.entry.audiences.company.cta"),
      image: companyImg,
      path: "companies",
    },
  ];

  return (
    <>
      {usePageMeta("home")}
      <div className="landing-entry">
        {/* Gradient accents */}
        <div className="landing-entry__gradient-1" />
        <div className="landing-entry__gradient-2" />

        <LandingHeader />

        <div className="landing-hero-section landing-entry__content">
          {/* Hero section */}
          <div className="landing-entry__hero">
            <h1 className="landing-entry__tagline">
              {t("landing.entry.tagline")}
            </h1>

            <p className="landing-entry__subtitle">
              {t("landing.entry.subtitle")}
            </p>
          </div>

          {/* "Who are you?" prompt */}
          <div className="landing-entry__prompt">
            <div className="landing-entry__prompt-line" />
            <span className="landing-entry__prompt-text">
              {t("landing.entry.whoAreYou")}
            </span>
            <div className="landing-entry__prompt-line" />
          </div>

          {/* Audience selection cards */}
          <div className="landing-entry__cards">
            {audiences.map((audience) => (
              <AudienceCard
                key={audience.variant}
                variant={audience.variant}
                title={audience.title}
                benefits={audience.benefits}
                cta={audience.cta}
                image={audience.image}
                onClick={() => navigate(audience.path)}
              />
            ))}
          </div>

          {/* Trust signal - Swiss made */}
          <div className="landing-entry__trust">
            <div className="landing-entry__trust-item landing-entry__trust-item--inline">
              <img
                src="https://flagcdn.com/w40/ch.webp"
                srcSet="https://flagcdn.com/w80/ch.webp 2x"
                alt="Switzerland"
                className="landing-entry__trust-item-flag"
              />
              <span className="landing-entry__trust-item-label">
                {t("landing.entry.trust.swissLabel")}
              </span>
            </div>
          </div>
        </div>

        <LandingFooter />
      </div>
    </>
  );
}

export default LandingEntry;
